import { TvButton, useAutoFocus } from '../tv';

export function BootScreen() {
  return (
    <div className="screen screen--centred">
      <div className="boot__spinner" role="status" aria-label="Starting" />
    </div>
  );
}

export interface BootErrorScreenProps {
  title?: string;
  message: string;
  onRetry: () => void;
}

/**
 * Not a sign-in screen — there is nothing for a player to supply.
 *
 * Reaching here means the device could not talk to Supabase at all, which on a
 * television is nearly always the network coming up slower than the app. So the
 * only control is Retry, and it starts focused so OK is enough.
 */
export function BootErrorScreen({
  title = 'Could not reach the server',
  message,
  onRetry,
}: BootErrorScreenProps) {
  const retryRef = useAutoFocus<HTMLButtonElement>();

  return (
    <div className="screen screen--centred">
      <h1 className="boot__title">{title}</h1>
      <p className="boot__detail" data-testid="boot-error">
        {message}
      </p>
      <p className="boot__detail">Check the network and try again.</p>
      <TvButton ref={retryRef} variant="primary" data-testid="boot-retry" onClick={onRetry}>
        Try again
      </TvButton>
    </div>
  );
}
